import * as React from "react";
import ReactStars from "react-stars";
import { countryFlagsUrl, stampedImageUrl } from "../../../../config";
import styles from "./list.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";

interface IListProps {
  reviews: any;
}

const getAuthorInitials = (name: string) => {
  const firstName = name.split(' ')[0]
  const lastName = name.split(' ')[1]

  return `${firstName.split('')[0]}${lastName.split('')[0]}`
}

const List = ({ reviews }: IListProps) => {
  return (
    <div className={styles.list}>
      {reviews?.map(
        ({
          reviewTitle,
          author,
          id,
          reviewMessage,
          avatar,
          location,
          reviewUserPhotos,
          reviewRating,
          reviewVerifiedType
        }: any) => (
          <div key={id} className={styles.item}>
            <div className={styles.author}>
              {reviewVerifiedType && (
                <div
                  className={styles.avatar}
                >
                  <h4>{getAuthorInitials(author)}</h4>
                  <i>
                    <FontAwesomeIcon icon={faCheckCircle} />
                  </i>
                </div>
              )}
              <div>
                <h4>
                  {author}
                  {reviewVerifiedType ? <span>Verified buyer</span> : ""}
                </h4>

                <p className={styles.location}>
                  <img
                    className={styles.flag}
                    src={countryFlagsUrl(location)}
                    alt="Flag"
                  />
                  {location}
                </p>

                <div className={styles.stars}>
                  <ReactStars
                    edit={false}
                    value={reviewRating}
                    color2="#ffd203"
                    color1="#ddd"
                    count={5}
                  />
                </div>
              </div>
            </div>

            {reviewTitle && <h3>{reviewTitle}</h3>}
            {reviewMessage && <p>{reviewMessage}</p>}

            {reviewUserPhotos.includes(",") ? (
              reviewUserPhotos
                ?.split(",")
                .map((reviewUserPhoto: any) => (
                  <img
                    key={reviewUserPhoto}
                    alt="User review"
                    src={stampedImageUrl(reviewUserPhoto)}
                  />
                ))
            ) : reviewUserPhotos.length ? (
              <img alt="User review" src={stampedImageUrl(reviewUserPhotos)} />
            ) : null}
          </div>
        )
      )}
    </div>
  );
};

export default List;
